import * as React from "react";
const SvgChevronFillLeft = (props) => /* @__PURE__ */ React.createElement("svg", props, /* @__PURE__ */ React.createElement("path", { d: "M29.341 6.691V33.31c0 2.393-2.896 3.59-4.585 1.9L11.447 21.902a2.673 2.673 0 0 1 0-3.791L24.756 4.79c1.689-1.689 4.585-.492 4.585 1.901Z" }));
export default SvgChevronFillLeft;
